<!--
  ~ Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
  ~ Spin in het Web B.V. Apeldoorn.
  ~ Deze software mag alleen gebruikt / bekeken / gewijzigd worden
  ~ volgens de voorwaarden die zijn vastgelegd in de overeenkomst
  ~ tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
  ~ overeenkomsten tussen Slimme Infrasoftware B.V en
  ~ Spin in het Web B.V.
  -->

<div class="head">
  <h1>{{ title }}</h1>
</div>
<div class="content">
  <form #form='ngForm'>
    <tabset [class.hideheading]="! projectSelectie">
      <tab heading="Basisgegevens">
        <div class="form-group">
          <label [for]="id('gebruikersnaam')">E-mailadres</label>
          <input type="text" [id]="id('gebruikersnaam')" name="gebruikersnaam" class="form-control" required email
                 autofocus
                 [(ngModel)]="record.gebruikersnaam">
        </div>
        <div class="form-group">
          <label [for]="id('naam')">Naam</label>
          <input type="text" [id]="id('naam')" name="naam" class="form-control" required [(ngModel)]="record.naam"
                 spellcheck="false">
        </div>
        <div class="form-group">
          <label [for]="id('wachtwoord')">Wachtwoord</label>
          <input type="text" [id]="id('wachtwoord')" name="wachtwoord" class="form-control" [required]="isNieuw"
                 minlength="6"
                 [(ngModel)]="record.wachtwoord">
          <small class="form-text text-muted"><span *ngIf="! isNieuw">Vul alleen een wachtwoord in als je het wilt
        wijzigen. </span>Minimum lengte: 6 tekens.</small>
        </div>
        <label>Werkmaatschappijen</label>
        <div class="form-row mb-2">
          <div class="w-col-6 w-col-sm-4 w-col-md-3 w-col-lg-2" *ngFor="let wm of werkmaatschappijen">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" name="wm_{{wm.id}}" [id]="id('wm_' + wm.id)"
                     [(ngModel)]="wm._tags.select">
              <label class="form-check-label" [for]="id('wm_' + wm.id)">{{ wm.naam }}</label>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label [for]="id('groep')">Groep</label>
          <select [id]="id('groep')" name="groep" class="form-control" required [(ngModel)]="record.groep_id">
            <option *ngFor="let groep of lookups.groep" [value]="groep.id">{{ groep.groep }}</option>
          </select>
          <small
            class="form-text text-muted">{{ groephash[record.groep_id]?.beschrijving }}</small>
        </div>
        <ng-container *ngIf="isLeverancierAccount">
          <div class="form-group">
            <label [for]="id('leverancier')">Leverancier</label>
            <select [id]="id('leverancier')" name="leverancier" class="form-control" required
                    [(ngModel)]="record.leverancier_id">
              <option *ngFor="let leverancier of leveranciersInWM()" [value]="leverancier.id">{{ leverancier.naam }}
                <span
                  *ngIf="geselecteerdeWerkmaatschappijen.length > 1">({{ $any(lookupHashes.werkmaatschappij[leverancier.werkmaatschappij_id])?.naam }}
                  )</span>
              </option>
            </select>
            <small class="form-text text-muted" *ngIf="geselecteerdeWerkmaatschappijen.length > 1">Let op: een gebruiker
              kan altijd maar in één divisie als leverancier plannen.</small>
          </div>
        </ng-container>
        <div class="form-row">
          <div class="w-col-md-4">
            <div class="form-group">
              <label [for]="id('actief')">Toegang tot applicatie <span class="inforondje" title="Een uitgeschakelde gebruiker kan niet inloggen en wordt op veel
            plekken standaard verborgen."></span> </label>
              <select [id]="id('actief')" name="actief" class="form-control" required [(ngModel)]="record.actief"
                      [disabled]="(editId && editId === api.uid)">
                <option [ngValue]="true">Actief</option>
                <option [ngValue]="false">Uitgeschakeld</option>
              </select>
            </div>
          </div>
          <div class="w-col-md-4">
            <div class="form-group">
              <label [for]="id('app_admin')">App-admin <span class="inforondje"
                                                             title="Een app-admin kan deze applicatie globaal beheren. Zo kan hij/zij gebruikers aanmaken en toekennen aan werkmaatschappijen - ook werkmaatschappijen waartoe hij/zij zelf geen toegang heeft. Een app-admin heeft alle rechten, ongeacht de ingestelde groep"></span></label>
              <select [id]="id('app_admin')" name="app_admin" class="form-control" required
                      [(ngModel)]="record.app_admin"
                      [disabled]="(editId && editId === api.uid)">
                <option [ngValue]="true">Ja</option>
                <option [ngValue]="false">Nee</option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label [for]="id('exact_admin')">Exact-admin <span class="inforondje"
                                                                 title="Een exact-admin kan de api-koppeling tussen ATRPlan en Exact herstellen. Hiervoor is in exact de toestemming &quot;Abonnement beheren&quot; nodig."></span></label>
              <select [id]="id('exact_admin')" name="exact_admin" class="form-control" required
                      [(ngModel)]="record.exact_admin">
                <option [ngValue]="true">Ja</option>
                <option [ngValue]="false">Nee</option>
              </select>
            </div>
          </div>
        </div>
      </tab>
      @if (projectSelectie) {
        <tab heading="Projecten">
          <p>Selecteer de projecten waartoe deze gebruiker toegang krijgt:</p>
          <div class="form-row">
            @for (project of projecten; track project) {
              @if (isGeselecteerdeWM(project.werkmaatschappij_id)) {
                <div class="w-col-6 w-col-sm-4 w-col-md-3 w-col-lg-2 mb-1">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" name="project_{{project.id}}"
                           [id]="id('project_' + project.id)"
                           [(ngModel)]="project._tags.select">
                    <label class="form-check-label" [for]="id('project_' + project.id)"
                           [attr.title]="project.labelMetKlant">{{ project.naam }}</label>
                  </div>
                </div>
              }
            }
          </div>
        </tab>
      }
    </tabset>
  </form>
</div>
<div class="foot">
  <div class="buttons" links>
    <button class="btn btn-secondary" (click)="closeWindow()">Annuleren</button>
    <button class="btn btn-danger" (click)="delete()"
            *ngIf="! readonly && ! isNieuw && ! (editId && editId === api.uid)" [disabled]="! canDelete"
            [attr.title]="canDelete? 'Verwijder deze gebruiker' : 'Deze gebruiker kan niet verwijderd worden, omdat ernaar wordt verwezen. Wel kan de toegang uitgeschakeld worden.'">
      Verwijderen
    </button>
  </div>
  <div class="buttons" rechts>
    <button class="btn btn-primary" (click)="save()" *ngIf="! (readonly || shouldReload )"
            [disabled]=" form.invalid || form.pristine || geselecteerdeWerkmaatschappijen.length === 0">
      Opslaan
    </button>
    <button class="btn btn-warning" (click)="reload()" *ngIf="shouldReload">Herladen (gewijzigd)</button>
  </div>
</div>
